import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const SearchSchema = z.object({
  freeText: z.string().optional(),
  pageSize: z.number().int().min(1).default(100),
  pageIndex: z.number().int().min(0).default(0),
  orderBy: z.enum(['name', 'count']).optional(),
  orderDirection: z.enum(['asc', 'desc']).optional(),
});

export const Route = createFileRoute('/_staff/software/$id/_$id/profiles')({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => ({ search }),
});
